<script>
  import { createEventDispatcher } from "svelte";
  import Dropdown from "../../../../ui/Dropdown.svelte";
  import { CAMPAIGN_STATUS, getCampaignStatusOptions } from "../../../../../utils/statusEngine.js";

  export let view = "free-spins";
  export let filters = createDefaultFilters();
  export let clients = [];
  export let icons = {};

  const dispatch = createEventDispatcher();

  const VIEW_OPTIONS = [
    { value: "free-spins", label: "Free Spins" },
    //{ value: "free-chips", label: "Free Chips" },
  ];
  const STATUS_OPTIONS = getCampaignStatusOptions();

  function createDefaultFilters() {
    return {
      client: "",
      clientId: "",
      campaignName: "",
      statuses: [CAMPAIGN_STATUS.ACTIVE, CAMPAIGN_STATUS.SCHEDULED],
      game: "",
      currency: "",
      player: "",
      bonus: "",
      dateFrom: "",
      dateTo: "",
    };
  }

  function setFilters(nextFilters) {
    filters = nextFilters;
    dispatch("filterchange", filters);
  }

  function clearFilters() {
    setFilters(createDefaultFilters());
  }

  function handleClientChange(event) {
    const clientCode = event.detail ?? "";
    const selected = (Array.isArray(clients) ? clients : []).find(
      (client) => String(client?.code ?? client?.clientCode) === String(clientCode),
    );
    setFilters({
      ...filters,
      client: clientCode,
      clientId: selected?.id ?? selected?.clientId ?? "",
    });
  }

  function updateFilter(key, value) {
    setFilters({ ...filters, [key]: value });
  }

  function handleStatusChange(event) {
    const statuses = Array.isArray(event.detail)
      ? event.detail.map(Number).filter(Number.isFinite)
      : [];
    updateFilter("statuses", statuses);
  }

  function changeView(event) {
    view = event.detail || view;
    setFilters(createDefaultFilters());
  }

  $: createLabel = view === "free-chips" ? "Crear Free Chip" : "Crear Free Spin";
</script>

<section class="filter-panel" aria-label="Filtros de campañas Pragmatic">
  <div class="filter-grid">
    <div class="field">
      <span class="field-label">Lista</span>
      <Dropdown
        options={VIEW_OPTIONS}
        value={view}
        valueKey="value"
        labelKey="label"
        clearable={false}
        on:change={changeView}
      />
    </div>

    <div class="field">
      <span class="field-label">Cliente</span>
      <Dropdown
        options={clients}
        value={filters.client}
        placeholder="Todos"
        valueKey="code"
        labelKey="namesite"
        isStructuredDescription={true}
        paramStructuredName={["code", "namesite"]}
        on:change={handleClientChange}
      />
    </div>

    <div class="field">
      <label for="pragmatic-campaign-filter">Campaña</label>
      <input
        id="pragmatic-campaign-filter"
        class="form-control"
        placeholder="Ej. Black Friday"
        value={filters.campaignName}
        on:input={(event) => updateFilter("campaignName", event.currentTarget.value)}
      />
    </div>

    <div class="field">
      <label for="pragmatic-game-filter">Juego</label>
      <input
        id="pragmatic-game-filter"
        class="form-control"
        placeholder="Nombre del juego"
        value={filters.game}
        on:input={(event) => updateFilter("game", event.currentTarget.value)}
      />
    </div>

    <div class="field">
      <span class="field-label">Estado</span>
      <Dropdown
        options={STATUS_OPTIONS}
        value={filters.statuses}
        placeholder="Todos"
        valueKey="value"
        labelKey="label"
        multiple={true}
        on:change={handleStatusChange}
      />
    </div>
  </div>

  <div class="toolbar">
    <button type="button" class="toolbar-button clear-button" on:click={clearFilters}>
      Limpiar
    </button>
    <button
      type="button"
      class="toolbar-button create-button"
      on:click={() => dispatch("create", { view })}
    >
      <span class="button-icon" aria-hidden="true">{@html icons.add || "+"}</span>
      {createLabel}
    </button>
  </div>
</section>

<style>
  .filter-panel {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.75rem;
    align-items: end;
    margin: 0 10px 0.5rem;
    padding: 0.75rem;
    border: 1px solid var(--bs-border-color, #e5e7eb);
    border-radius: 0.5rem;
    background: #fff;
  }
  .filter-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(140px, 1fr));
    gap: 0.6rem;
    align-items: end;
  }
  .field {
    display: flex;
    min-width: 0;
    flex-direction: column;
  }
  .field label,
  .field-label {
    display: block;
    margin-bottom: 0.3rem;
    color: #666;
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .field input {
    min-height: 38px;
    padding: 0.4rem 0.55rem;
    border: 1px solid var(--bs-border-color, #e2e6ea);
    border-radius: 0.4rem;
    background: #fff;
    color: #333;
    font-size: 0.875rem;
  }
  .toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
  }
  .toolbar-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    min-width: max-content;
    padding: 0 1rem;
    border-radius: 0.4rem;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
  }
  .create-button {
    gap: 0.4rem;
    border: 1px solid #2a1a28;
    background: #2a1a28;
    color: #fff;
  }
  .create-button:hover {
    border-color: #ff0090;
    background: #ff0090;
  }
  .clear-button {
    border: 1px solid #cfc8cd;
    background: #fff;
    color: #2a1a28;
  }
  @media (max-width: 1200px) {
    .filter-panel { grid-template-columns: 1fr; }
    .filter-grid { grid-template-columns: repeat(3, 1fr); }
    .toolbar { justify-content: flex-start; }
  }
  @media (max-width: 640px) {
    .filter-grid { grid-template-columns: 1fr; }
  }
</style>
